import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {

    public isLoading = new BehaviorSubject(false);
    public isUploading = new BehaviorSubject<{ status: boolean; message: string }>({
        status: false,
        message: ''
    });
    
    constructor() { }

}
